import { GuideStep } from 'entities/Guide';
import { Language } from 'entities/Language';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'shared/_ui';
import { getImageByParams } from '../lib/utils/getImageByParams';
import { Device } from 'entities/Device';
import { Installation } from 'entities/Installation';
import { translationEn } from 'locales/en/translation';

interface InstructionTemplate {
    device: Device;
    installationType: Installation;
    copyLink: React.ReactElement;
}

export const Instruction: React.FC<InstructionTemplate> = ( {
    device, 
    installationType,
    copyLink
} ) => {
  const { t, i18n } = useTranslation();
  const getImageByStep = getImageByParams(
    device,
    i18n.language as Language
  );
  
  const steps = translationEn["guide"][device][installationType]["step"];

  return <Flex direction="column">
    {
        Object.keys(steps).map( (i) =>
          <GuideStep
            number={+i}
            title={t(`guide.${device}.${installationType}.step.${i}.title`)}
            final={+i === Object.keys(steps).length}
            image={getImageByStep(+i)}
            description={
                <ol>
                    {Object.keys(steps[i as '1']["description"]).map((j) =>
                      <li>{t(`guide.${device}.${installationType}.step.${i}.description.${j}`)}</li>
                    )}
                    {+i === 3 && copyLink}
                </ol>
            }
          /> )
    }
  </Flex>
}